import { useEffect, useState } from "react";

export default function Pagination({
  perPage,
  setPerPage,
  setCurrentPage,
  currentPage,
  totalPages,
  totalResults,
}) {
  const BATCH_SIZE = 5;
  const [batchStart, setBatchStart] = useState(1);

  // Shift batch when currentPage moves outside batch
  useEffect(() => {
    const newBatchStart =
      Math.floor((currentPage - 1) / BATCH_SIZE) * BATCH_SIZE + 1;
    setBatchStart(newBatchStart);
  }, [currentPage]);

  const batchEnd = Math.min(batchStart + BATCH_SIZE - 1, totalPages);
  const pageNumbers = [];
  for (let i = batchStart; i <= batchEnd; i++) pageNumbers.push(i);

  return (
    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
      {/* Per-page selector */}
      <div className="d-flex align-items-center gap-2">
        <span>Show</span>
        <select
          className="form-select"
          style={{ width: "80px" }}
          value={perPage}
          onChange={(e) => {
            setPerPage(parseInt(e.target.value, 10));
            setCurrentPage(1); // reset to first page
          }}
        >
          {[5, 10, 20, 50].map((num) => (
            <option key={num} value={num}>
              {num}
            </option>
          ))}
        </select>
        <span>per page</span>
      </div>

      {/* Pagination */}
      <div className="d-flex align-items-center gap-2 flex-wrap justify-content-end">
        <span className="text-muted" style={{ fontSize: "0.9rem" }}>
          {totalResults === 0
            ? "0"
            : `${(currentPage - 1) * perPage + 1} - ${Math.min(
                currentPage * perPage,
                totalResults
              )}`}{" "}
          of {totalResults}
        </span>
        <nav>
          <ul className="pagination pagination-sm mb-0">
            {/* Previous page */}
            <li className={`page-item ${currentPage === 1 && "disabled"}`}>
              <button
                className="page-link"
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              >
                &lt;
              </button>
            </li>

            {/* Page numbers in current batch */}
            {pageNumbers.map((num) => (
              <li
                key={num}
                className={`page-item ${currentPage === num ? "active" : ""}`}
              >
                <button
                  className="page-link text-dark"
                  style={{ backgroundColor: "#F1F1F4" }}
                  onClick={() => setCurrentPage(num)}
                >
                  {num}
                </button>
              </li>
            ))}

            {/* Next page */}
            <li
              className={`page-item ${currentPage === totalPages && "disabled"}`}
            >
              <button
                className="page-link"
                onClick={() =>
                  setCurrentPage((p) => Math.min(p + 1, totalPages))
                }
              >
                &gt;
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
